async function devtricker_checkAndUpdateNonce() {
    try {
        let nonce = devtricker_session_getNonce();

        if (!nonce) {
            nonce = await devtricker_ajax_get_getDevtrickerNonce();
            devtricker_session_setNonce(nonce);
            devtricker_log(null, devtricker_log_level.INFO, 'Nonce updated.');
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Failed to update nonce.');
    }
}

document.addEventListener("DOMContentLoaded", (event) => {

    const loggedUser = devtricker_getTheLoggedUserId();

    if (loggedUser) {
        devtricker_checkAndUpdateNonce();
    }
});